<template>
  <div class="w-100">
    <loading-spinner v-if="isLoading" />

    <ul class="nav nav-tabs mb-3">
      <li class="nav-item">
        <button class="nav-link" :class="{ active: activeTab === 'hq' }" @click="activeTab = 'hq'">
          HQ Budget
        </button>
      </li>
      <li class="nav-item">
        <button class="nav-link" :class="{ active: activeTab === 'district' }" @click="activeTab = 'district'">
          District Budget
        </button>
      </li>
      <li class="nav-item">
        <button class="nav-link" :class="{ active: activeTab === 'expenses' }" @click="activeTab = 'expenses'">
          Expenses
        </button>
      </li>
    </ul>

    <hq-budget-tab
      v-if="activeTab === 'hq'"
      :selected-year="selectedYear"
      :hq="hq"
      :lines="lines"
      @saved="loadHq"
    />

    <district-split-tab
      v-if="activeTab === 'district'"
      :selected-year="selectedYear"
      :lines="lines"
    />

    <expenses-tab
      v-if="activeTab === 'expenses'"
      :selected-year="selectedYear"
      :hq="hq"
      :lines="lines"
    />
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";
import HqBudgetTab from "@/views/Manage/budget/HqBudgetTab";
import DistrictSplitTab from "@/views/Manage/budget/DistrictSplitTab";
import ExpensesTab from "@/views/Manage/budget/ExpensesTab";

export default {
  props: ["selectedYear"],
  components: {
    LoadingSpinner,
    HqBudgetTab,
    DistrictSplitTab,
    ExpensesTab,
  },
  data() {
    return {
      isLoading: false,
      activeTab: "hq",
      hq: null,
      lines: [],
    };
  },
  watch: {
    selectedYear: {
      handler() {
        this.loadHq();
      },
      immediate: false,
    },
  },
  methods: {
    async loadHq() {
      this.isLoading = true;
      try {
        const year = this.selectedYear || this.Helper.currentYear;
        const [hqCall] = await this.Helper.handlePromise(
          this.API.get(`nod-budget-hqs?year=${year}`)
        );
        this.hq = hqCall && hqCall.data && hqCall.data.length ? hqCall.data[0] : null;

        if (this.hq) {
          const [lineCall] = await this.Helper.handlePromise(
            this.API.get(`nod-budget-lines?hq=${this.hq.id}&_limit=-1`)
          );
          this.lines = lineCall && lineCall.data ? lineCall.data : [];
        } else {
          this.lines = [];
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    await this.loadHq();
  },
};
</script>
